import { Customer } from "@hydrologiq/gql-experience/graphql"
import CurrentOrderStatus from "../generic/CurrentOrderStatus"

interface CustomerCurrentOrderProps {
  context?: Customer
  loading: boolean
  error: string | undefined
}

const CustomerCurrentOrder = ({ context, loading, error }: CustomerCurrentOrderProps) => {
  const orders = context?.currentOrders || []

  return <CurrentOrderStatus orders={orders} customerId={context?.id} loading={loading} error={error} />
}

export default CustomerCurrentOrder
